import { useDispatch, useSelector } from "react-redux";
import { downloadAccountingOrderButton } from "../thunks/loadAccountingOrderButton";
import { resteData } from "../accountingOrderDataSlice";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { InvoiceListData } from "../types";

export const useAccountingOrderButton = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.accounting.accountingOrder.downloadReportFetchState
	);

	const data = useSelector<StoreType, InvoiceListData[] | undefined>(
		s => s.data.accounting.accountingOrder.data
	);

	const hasData = data !== undefined && data.length > 0;

	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadAccountingOrderButton()), [dispatch]);

	const dispatchResetData = React.useCallback(() => {
		dispatch(resteData());
	}, [dispatch]);

	return [download, fetchState, dispatchResetData, hasData] as [
		typeof download,
		typeof fetchState,
		typeof dispatchResetData,
		typeof hasData
	];
};
